// removed by extract-text-webpack-plugin
module.exports = {"field-list":"field-list__field-list","field-list-item":"field-list__field-list-item","field-list-no-wildcards":"field-list__field-list-no-wildcards"};


//////////////////
// WEBPACK FOOTER
// ./src/components/data-pane/field-list.scss
// module id = 1212
// module chunks = 0